<template>
  <div class="full-page-width relative locations">
    <Btn
      class="brand off-position"
      :icon="{
        name: 'add',
        size: '18',
        color: '#fff',
      }"
      btnText="Add Shipping Method"
      @btnClick="openNewPopup"/>
    <div class="row">
      <div class="col-xs-4 text-box">
        <h2>Shipping Methods</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Ut consectetur nunc tincidunt venenatis tincidunt.
          Aenean consectetur iaculis posuere.
        </p>
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            v-for="(item, index) in get_shipping_methods.items" :key="`item-${index}`">
            <div class="table-cell small">
              <Icon
                :circle=true
                name="preview"
                size="20"/>
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.name}` }}
              </span>
                <span class="additional-info">Additional info</span>
              </p>
            </div>
            <Btn
              class="button brand"
              :icon="{
                name: 'pen',
                size: '18',
                color: '#fff',
              }"
              btnText="Edit"
              @btnClick="openEditPopup(item.id)"/>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>Add Shipping Method</h2>
      </template>
      <div>
        <div class="row">
          <InputText
            class="col-xs-12"
            placeholder="Import shipping name"
            label="Import shipping name (required)"
            v-model="form.name"/>
        </div>
        <div class="row">
          <InputText
            class="col-xs-6"
            placeholder="shipping_product_id"
            label="shipping_product_id (required)"
            v-model="form.shipping_product_id"/>
          <InputText
            class="col-xs-6"
            placeholder="sender_id"
            label="sender_id"
            v-model="form.sender_id"/>
        </div>
        <div class="row">
          <InputText
            class="col-xs-6"
            placeholder="is_autoprint"
            label="is_autoprint (required)"
            v-model="form.is_autoprint"/>
          <InputText
            class="col-xs-6"
            placeholder="is_sending_and_return"
            label="is_sending_return (required)"
            v-model="form.is_sending_and_return"/>
        </div>
        <div class="row">
          <InputText
            class="col-xs-6"
            placeholder="subcategories_json"
            label="subcategories_json"
            v-model="form.subcategories_json"/>
          <InputText
            class="col-xs-6"
            placeholder="return_subcategories_json"
            label="return_subcategories_json"
            v-model="form.return_subcategories_json"/>
        </div>
        <div class="row">
          <InputText
            class="col-xs-6"
            placeholder="pallet_type"
            label="pallet_type"
            v-model="form.pallet_type"/>
          <InputText
            class="col-xs-6"
            placeholder="return_shipping_product_id"
            label="return_shipping_product_id"
            v-model="form.return_shipping_product_id"/>
          <InputText
            class="col-xs-6"
            placeholder="send_to_print"
            label="send_to_print"
            v-model="form.send_to_print"/>
          <InputText
            class="col-xs-6"
            placeholder="is_droppoint"
            label="is_droppoint"
            v-model="form.is_droppoint"/>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>/* eslint-disable */
import {mapGetters} from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';

export default {
  components: {Btn, Popup, InputText},
  data() {
    return {
      openPopup: false,
      isEdit: false,
      shippingMethodId: '',
      form: {
        name: '',
        shipping_product_id: '',
        is_droppoint: '',
        sender_id: '',
        is_autoprint: '',
        subcategories_json: '',
        pallet_type: '',
        return_shipping_product_id: '',
        return_subcategories_json: '',
        send_to_print: '',
        is_sending_and_return: ''
      },
    };
  },
  computed: {
    ...mapGetters([
      'get_shipping_methods',
      'get_shipping_method_by_id'
    ]),
  },
  created() {
    this.$store.dispatch('GET_SHIPPING_METHODS');
  },
  methods: {
    clearLocalFormData() {
      this.form = {
        name: '',
        shipping_product_id: '',
        is_droppoint: '',
        sender_id: '',
        is_autoprint: '',
        subcategories_json: '',
        pallet_type: '',
        return_shipping_product_id: '',
        return_subcategories_json: '',
        send_to_print: '',
        is_sending_and_return: ''
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.shippingMethodId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_SHIPPING_METHOD' : 'SET_SHIPPING_METHOD';

      this.$store.dispatch(`${action}`, {
        form: this.form,
        id: this.shippingMethodId || '',
      }).then(() => {
        this.$store.dispatch('GET_SHIPPING_METHODS');
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    openNewPopup() {
      this.isEdit = false;
      this.togglePopup();
    },
    openEditPopup(id) {
      this.togglePopup();
      this.isEdit = true;
      this.shippingMethodId = id;
      this.form = {...this.get_shipping_method_by_id(id)};
    },
  },

}
</script>
